import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { formatApiError } from "../lib/api";
import { Camera, ArrowLeft, Loader2 } from "lucide-react";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

export default function RegisterPage() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (password.length < 6) {
      setError("A senha deve ter no minimo 6 caracteres");
      return;
    }
    setLoading(true);
    try {
      await register(email, password, name);
      navigate("/dashboard");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FFFBF7] flex flex-col" data-testid="register-page">
      <header className="sticky top-0 w-full bg-[#FFFBF7]/80 backdrop-blur-xl border-b-2 border-[#1C1917] z-40">
        <div className="max-w-7xl mx-auto px-4 py-3 flex items-center gap-3">
          <Link to="/" className="flex items-center gap-2">
            <ArrowLeft className="w-5 h-5" strokeWidth={2.5} />
          </Link>
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 bg-[#FF6B6B] border-2 border-[#1C1917] rounded-lg flex items-center justify-center shadow-[2px_2px_0px_#1C1917]">
              <Camera className="w-4 h-4 text-white" strokeWidth={2.5} />
            </div>
            <span className="font-black text-lg tracking-tight text-[#1C1917]" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>Festa.IA</span>
          </div>
        </div>
      </header>

      <div className="flex-1 flex items-center justify-center px-4 py-12">
        <div className="w-full max-w-sm">
          <div className="bg-white border-2 border-[#1C1917] shadow-[6px_6px_0px_#1C1917] rounded-xl p-6 sm:p-8">
            <h1 className="text-2xl font-black text-[#1C1917] mb-1" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>Criar Conta</h1>
            <p className="text-sm text-[#78716C] mb-6">Cadastre-se para organizar eventos</p>

            {error && (
              <div className="bg-[#FEE2E2] border-2 border-[#1C1917] rounded-lg p-3 mb-4 text-sm text-[#1C1917] font-medium" data-testid="register-error">
                {error}
              </div>
            )}

            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <Label className="text-sm font-bold text-[#1C1917]">Nome</Label>
                <Input
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="Seu nome"
                  required
                  className="mt-1 border-2 border-[#1C1917] rounded-lg"
                  data-testid="register-name-input"
                />
              </div>
              <div>
                <Label className="text-sm font-bold text-[#1C1917]">Email</Label>
                <Input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="seu@email.com"
                  required
                  className="mt-1 border-2 border-[#1C1917] rounded-lg"
                  data-testid="register-email-input"
                />
              </div>
              <div>
                <Label className="text-sm font-bold text-[#1C1917]">Senha</Label>
                <Input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Min. 6 caracteres"
                  required
                  className="mt-1 border-2 border-[#1C1917] rounded-lg"
                  data-testid="register-password-input"
                />
              </div>
              <Button
                type="submit"
                disabled={loading}
                className="w-full bg-[#FF6B6B] text-white border-2 border-[#1C1917] shadow-[4px_4px_0px_#1C1917] rounded-full font-bold py-3 hover:translate-y-[2px] hover:shadow-[2px_2px_0px_#1C1917] transition-all active:translate-y-[4px] active:shadow-none"
                data-testid="register-submit-btn"
              >
                {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : "Criar Conta"}
              </Button>
            </form>

            <p className="text-center text-sm text-[#78716C] mt-6">
              Ja tem conta?{" "}
              <Link to="/login" className="text-[#FF6B6B] font-bold hover:underline" data-testid="go-to-login">
                Entrar
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
